import { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import useIosInstallPrompt from "../hooks/useIosInstallPrompt";
import useWebInstallPrompt from "../hooks/useWebInstallPrompt";
import { IoShareOutline } from "react-icons/io5";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "70%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  install: {
    display: "flex",
    justifyContent: "space-around",
  },
  close: {
    display: "flex",
    justifyContent: "center",
  },
}));

const InstallPWA = () => {
  const classes = useStyles();

  const [open, setOpen] = useState(true);
  const [iosInstallPrompt, handleIOSInstallDeclined] = useIosInstallPrompt();
  const [
    webInstallPrompt,
    handleWebInstallDeclined,
    handleWebInstallAccepted,
  ] = useWebInstallPrompt();

  const handleClose = () => {
    setOpen(false);
  };

  if (!iosInstallPrompt && !webInstallPrompt) {
    return null;
  }

  const body = (
    <div className={classes.paper}>
      <h2 id="simple-modal-title">App installieren</h2>
      {iosInstallPrompt && (
        <>
          <p>
            {`Tippe auf `}
            <IoShareOutline />
            {` und dann "Zum Home-Bildschirm"`}
          </p>
          <div className={classes.close}>
            <Button color="secondary" onClick={handleIOSInstallDeclined}>
              Schließen
            </Button>
          </div>
        </>
      )}
      {webInstallPrompt && (
        <div className={classes.install}>
          <Button color="primary" onClick={handleWebInstallAccepted}>
            Installieren
          </Button>
          <Button color="secondary" onClick={handleWebInstallDeclined}>
            Schließen
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.modal}
    >
      {body}
    </Modal>
  );
};

export default InstallPWA;
